/**
 * pf-tracking.js
 * ─────────────────────────────────────────────────────────────────────────────
 * 1. Reads tracking params from the URL on page load → window.pfTracking
 * 2. On drawer open, populates all hidden tracking fields from window.pfTracking
 * 3. Survives fetch-swap navigation (sort/filter) by re-reading from
 *    window.pfTracking (already captured from the original landing URL)
 *
 * Params captured:
 *   LeadByte core  : ssid, campid
 *   GA4            : gclid, utm_source, utm_medium, utm_campaign,
 *                    utm_term, utm_content
 *   Facebook       : fbclid, fb_ad_id, fb_ad_name, fb_adset_name,
 *                    fb_campaign_name, fb_placement, fb_site_source_name,
 *                    fbp, fbc, fb_adset_id, fb_campaign_id,
 *                    fb_adid (alt param)
 *   TikTok         : ttclid, tt_campaign, tt_adgroup, tt_ad, tt_adid
 *   Internal       : campaign (salt_campaign_name)
 * ─────────────────────────────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  /* ── 1. Capture URL params once on page load ── */
  var params = new URLSearchParams(window.location.search);

  window.pfTracking = {
    /* LeadByte core */
    ssid:                 params.get('ssid')                 || 'ORGANIC',
    campid:               params.get('campid')               || '',
    salt_campaign_name:   params.get('campaign')             || '',
    source:               window.location.href,

    /* GA4 */
    gclid:                params.get('gclid')                || '',
    ga_campaign:          params.get('utm_campaign')         || '',
    ga_advertid:          params.get('utm_content')          || '',
    ga_adkey:             params.get('utm_term')             || '',
    ga_adgroup:           params.get('utm_medium')           || '',

    /* Facebook */
    fbclid:               params.get('fbclid')               || '',
    fb_ad_id:             params.get('fb_ad_id')             || params.get('fb_adid') || '',
    fb_ad_name:           params.get('fb_ad_name')           || '',
    fb_adset_name:        params.get('fb_adset_name')        || '',
    fb_campaign_name:     params.get('fb_campaign_name')     || '',
    fb_placement:         params.get('fb_placement')         || '',
    fb_site_source_name:  params.get('fb_site_source_name')  || '',
    fbp:                  params.get('fbp')                  || '',
    fbc:                  params.get('fbc')                  || '',
    fb_adset_id:          params.get('fb_adset_id')          || '',
    fb_campaign_id:       params.get('fb_campaign_id')       || '',

    /* TikTok */
    ttclid:               params.get('ttclid')               || '',
    tt_campaign:          params.get('tt_campaign')          || '',
    tt_adgroup:           params.get('tt_adgroup')           || '',
    tt_ad:                params.get('tt_ad')                || '',
    tt_adid:              params.get('tt_adid')              || '',

    /* Geo — empty on load, filled at submit time by pf-form.js via ipapi.co */
    country:    '',
    ipaddress:  '',
    towncity:   '',
    county:     '',
    postcode:   '',
    latitude:   '',
    longitude:  ''
  };

  /* ── 2. Populate hidden fields in a form ──
     Call this whenever a drawer/form is opened or re-rendered.
     Matches field IDs defined in pf-tracking-fields.liquid.            */
  window.pfTracking.populate = function () {
    var map = {
      'pf-field-ssid':              window.pfTracking.ssid,
      'pf-field-source':            window.pfTracking.source,
      'pf-field-campaign-name':     window.pfTracking.salt_campaign_name,

      /* GA4 */
      'pf-field-gclid':             window.pfTracking.gclid,
      'pf-field-ga-campaign':       window.pfTracking.ga_campaign,
      'pf-field-ga-advertid':       window.pfTracking.ga_advertid,
      'pf-field-ga-adkey':          window.pfTracking.ga_adkey,
      'pf-field-ga-adgroup':        window.pfTracking.ga_adgroup,

      /* Facebook */
      'pf-field-fbclid':            window.pfTracking.fbclid,
      'pf-field-fb-ad-id':          window.pfTracking.fb_ad_id,
      'pf-field-fb-ad-name':        window.pfTracking.fb_ad_name,
      'pf-field-fb-adset-name':     window.pfTracking.fb_adset_name,
      'pf-field-fb-campaign-name':  window.pfTracking.fb_campaign_name,
      'pf-field-fb-placement':      window.pfTracking.fb_placement,
      'pf-field-fb-site-source':    window.pfTracking.fb_site_source_name,
      'pf-field-fbp':               window.pfTracking.fbp,
      'pf-field-fbc':               window.pfTracking.fbc,
      'pf-field-fb-adset-id':       window.pfTracking.fb_adset_id,
      'pf-field-fb-campaign-id':    window.pfTracking.fb_campaign_id,

      /* TikTok */
      'pf-field-ttclid':            window.pfTracking.ttclid,
      'pf-field-tt-campaign':       window.pfTracking.tt_campaign,
      'pf-field-tt-adgroup':        window.pfTracking.tt_adgroup,
      'pf-field-tt-ad':             window.pfTracking.tt_ad,
      'pf-field-tt-adid':           window.pfTracking.tt_adid
    };

    Object.keys(map).forEach(function (id) {
      var el = document.getElementById(id);
      if (el && map[id]) el.value = map[id];
    });
  };

  /* ── 3. Auto-populate on drawer open ──
     Listens for the drawer open event fired by pf-quick-apply.js.
     Also exposed as window.pfTracking.populate() for manual calls.    */
  document.addEventListener('pf:drawer:open', function () {
    window.pfTracking.populate();
  });

})();